import React, { useEffect, useCallback, useMemo, useRef, useState, memo } from "react";
import MobileDetect from "mobile-detect";
import DOMPurify from 'dompurify';
import Button from "@mui/material/Button";

import bopomofoImg from "../../../assets/images/screen_icons/bopomofo.svg";

import { random } from "../../../utils/actions";

import { screenState } from "../../../store/screen/slice";
import { useAppSelector } from "../../../store/hooks";

const Index = (props: any) => {
  const { username } = useAppSelector(state => screenState(state));
  const { config, scale, onSelect, onUpdate, actionEnd, toSpotlight, setCanCopy } = props;
  const iframeRef = useRef(null);
  const [writingType, setWritingType] = useState<boolean>(false);
  const [fontSizeSet, setFontSizeSet] = useState<any>(32);
  const [fontSpaceSet, setFontSpaceSet] = useState<any>(0);
  const [floatBtn, setFloatBtn] = useState<boolean>(false);
  const [isIPad, setIsIPad] = useState<boolean>( /iPad/.test(navigator.userAgent) || (navigator.userAgent.includes("Mac") && "ontouchend" in document));

  const iPadCheck = () => {
    const isIOS = /iPad/.test(navigator.userAgent) || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
    return isIOS;
  };
  
  useEffect(() => {
    if (iPadCheck()) {
      setIsIPad(true);
    } else {
      setIsIPad(false);
    }
  }, []);

  useEffect(() => {
    console.log(iPadCheck());
    console.log('fontSizeSet', fontSizeSet);
    console.log('scale', scale);
    
    
  }, [fontSizeSet, scale]);

  useEffect(() => {
    if (config.data && config.data.data?.content && config.data.data?.triggered) {
      const iframe: any = iframeRef.current;
      if (!iframe) return;
      const iframeWindow = iframe.contentWindow;
      if (iframeWindow) {
        iframeWindow.postMessage({
          type: "data",
          data: config.data.data?.content
        }, '*');
        iframeWindow.postMessage({
          type: "fontSize",
          data: config.data.data?.fontSize
        }, '*');
        iframeWindow.postMessage({
          type: "fontSpace",
          data: config.data.data?.fontSpace
        }, '*');
        iframeWindow.postMessage({
          type: "writing",
          data: config.data.data?.writing
        }, '*');
      }
      delete config.data.data.triggered;

      if (config.data && config.data.data?.writing !== "") {
        if (config.data.data?.writing === "Horizontal") {
          setWritingType(false);
        } else if (config.data.data?.writing === "Vertical") {
          setWritingType(true);
        }
      }
    }
  }, [config.data.data?.content]);

  useEffect(() => {
    if (config.data && config.data.data?.fontSize) {
      const size = Number(config.data.data?.fontSize);
      setFontSizeSet(size);
    }
  }, [config.data.data?.fontSize]);

  useEffect(() => {
    if (config.data && config.data.data?.fontSpace && config.data.data?.writing) {
      const Gap = Number(config.data.data?.fontSpace) / 10;
      let defValue = 1.2;
      if (config.data.data?.writing === "Horizontal") {
        defValue = 1.2;
      } else if (config.data.data?.writing === "Vertical") {
        defValue = 2;
      }
      const gap = Gap + defValue;
      setFontSpaceSet(gap);
    }
  }, [config.data.data?.fontSpace]);

  useEffect(() => {
    if (config.data && config.data.data?.writing !== "") {
      if (config.data.data?.writing === "Horizontal") {
        setWritingType(false);
      } else if (config.data.data?.writing === "Vertical") {
        setWritingType(true);
      }
    }
  }, [config.data.data?.writing]);

  useEffect(() => {
    if (config.writingType) {
      const iframe: any = iframeRef.current;
      if (!iframe) return;
      const iframeWindow = iframe.contentWindow;
      if (iframeWindow) {
        iframeWindow.postMessage({
          type: "writing",
          data: config.writingType
        }, '*');
      }
      // 
      const data = config.data.data;
      data.writing = config.writingType;
      const update: any = { id: config.data.id, data: data };
      if ((!username && !config?.data.studentName) || username === config.data.studentName) {
        onUpdate(update);
        actionEnd(true);
      }
    }
  }, [config.writingType]);

  useEffect(() => {
    if (config.showFontSetting !== null) {
      const iframe: any = iframeRef.current;
      if (!iframe) return;
      const iframeWindow = iframe.contentWindow;
      if (iframeWindow) {
        iframeWindow.postMessage({
          type: "fontSetting",
          data: config.showFontSetting
        }, '*');
      }
    }
  }, [config.showFontSetting]);

  useEffect(() => {
    if (config.data.theme) {
      const iframe: any = iframeRef.current;
      if (!iframe) return;
      const iframeWindow = iframe.contentWindow;
      if (iframeWindow) {
        iframeWindow.postMessage({
          type: "theme",
          data: config.data.theme
        }, '*');
      }
    }
  }, [config.data.theme]);

  useEffect(() => {
    if (config.data.data?.fontSize) {
      const iframe: any = iframeRef.current;
      if (!iframe) return;
      const iframeWindow = iframe.contentWindow;
      if (iframeWindow) {
        iframeWindow.postMessage({
          type: "fontSize",
          data: config.data.data?.fontSize
        }, '*');
      }
    }
  }, [config.data.data?.fontSize]);

  useEffect(() => {
    if (config.data.data?.fontSpace) {
      const iframe: any = iframeRef.current;
      if (!iframe) return;
      const iframeWindow = iframe.contentWindow;
      if (iframeWindow) {
        iframeWindow.postMessage({
          type: "fontSpace",
          data: config.data.data?.fontSpace
        }, '*');
      }
    }
  }, [config.data.data?.fontSpace]);

  useEffect(() => {
    if (scale) {
      const iframe: any = iframeRef.current;
      if (!iframe) return;
      const iframeWindow = iframe.contentWindow;
      if (iframeWindow) {
        iframeWindow.postMessage({
          type: "zoom",
          data: scale
        }, '*');
      }
    }
  }, [scale]);

  useEffect(() => {
    const {FontSize, FontSpace} = config;
    if (FontSize || FontSpace) {
      const data = config.data.data;
      data.fontSize = FontSize;
      data.fontSpace = FontSpace;
      const update: any = { id: config.data.id, data: data };
      if ((!username && !config?.data.studentName) || username === config.data.studentName) {
        onUpdate(update);
        actionEnd(true);
      }
    }
  }, [config.FontSize, config.FontSpace]);

  useEffect(() => {
    // 
  }, [config.data.selected]);

  useEffect(() => {
    const iframe: any = iframeRef.current;
    if (!iframe) return;

    const handleIframeLoad = () => {
      const iframeWindow = iframe.contentWindow;
      if (iframeWindow) {
        iframeWindow.postMessage({
          type: "data",
          data: config.data.data?.content
        }, '*');
        iframeWindow.postMessage({
          type: "writing",
          data: config.writingType
        }, '*');
        iframeWindow.postMessage({
          type: "theme",
          data: config.data.theme
        }, '*');
        iframeWindow.postMessage({
          type: "fontSize",
          data: config.data.data?.fontSize
        }, '*');
        iframeWindow.postMessage({
          type: "fontSpace",
          data: config.data.data?.fontSpace
        }, '*');
        iframeWindow.postMessage({
          type: "fontSetting",
          data: config.showFontSetting
        }, '*');
        iframeWindow.postMessage({
          type: "zoom",
          data: scale
        }, '*');
      }

      iframe.contentWindow.document.addEventListener('click', () => {
        handleIframeClick();
      });
      iframe.contentWindow.document.addEventListener("focus", () => {
        setCanCopy(false);
      });
      iframe.contentWindow.document.addEventListener("blur", () => {
        setCanCopy(true);
      });
    };

    iframe.addEventListener('load', handleIframeLoad);

    // 
    const handleIframeMessage = (event: any) => {
      if (event.data.identifier === config.data.id) {
        const DATA = event.data.data;
        const WRITING = event.data.writingType;
        const FONTSIZE = event.data.fontSize;
        const FONTSPACE = event.data.fontSpace;
        const data = config.data.data;
        data.content = DATA;
        data.writing = WRITING;
        data.fontSize = FONTSIZE;
        data.fontSpace = FONTSPACE;
        const listTitle = event.data.data;
        const update: any = { id: config.data.id, data: data };
        if (listTitle !== "") {
          update["listTitle"] = event.data.data;
        }
        if ((!username && !config?.data.studentName) || username === config.data.studentName) {
          onUpdate(update);
          actionEnd(true);
        }
      }

      if (event.data.dblclick) {
        if (event.source === iframe.contentWindow) {
          toSpotlight();
        }
      }
      
      if (event.data.onchange) {
        if (event.source === iframe.contentWindow) {
          const data = config.data.data;
          const onchange = event.data.onchange;
          data.content = onchange.text;
          data.html = onchange.html;
          const update: any = { id: config.data.id, data: data };
          if ((!username && !config?.data.studentName) || username === config.data.studentName) {
            onUpdate(update);
            actionEnd(true);
          }
        }
      }
    };
    window.addEventListener("message", handleIframeMessage);

    // 
    return () => {
      if (iframe.contentWindow) {
          iframe.contentWindow.document.removeEventListener('click', handleIframeLoad);
      }

      window.removeEventListener("message", handleIframeMessage);
    };

  }, [config.showFontSetting]);

  const handleIframeClick = () => {
    onSelect("", config.data.id);
    // if (!config.data.selected) {
    //   onUpdate({ id: config.data.id, selected: true });
    // }
  };

  const writingSwitch = () => {
    setWritingType(!writingType);
  };

  useEffect(() => {
    if (config.data && config.data.data?.fontSpace && config.data.data?.writing) {
      const Gap = Number(config.data.data?.fontSpace) / 10;
      let defValue = 1.2;
      if (!writingType) {
        defValue = 1.2;
      } else {
        defValue = 2;
      }
      const gap = Gap + defValue;
      setFontSpaceSet(gap);
    }
  }, [writingType]);

  const saveBopomofo = useCallback(() => {
    const iframe: any = iframeRef.current;
    if (!iframe) return;
    const iframeWindow = iframe.contentWindow;
    if (iframeWindow) {
      if (floatBtn) {
      iframeWindow.postMessage({
        type: "save",
        data: false
      }, '*');
        setFloatBtn(false);
      } else {
      iframeWindow.postMessage({
        type: "save",
        data: true
      }, '*');
        setFloatBtn(true);
      }
    }
  }, [floatBtn, iframeRef.current]);

  return (
    <React.Fragment>
      <div className="componentCore readCore h-100 w-100 rounded-lg">
        <div className="text-box h-100 w-100 overflow-hidden" style={{ cursor: 'text', overflow: 'auto' }}>
          {!username? (
            <iframe
              ref={iframeRef}
              className="h-100 w-100"
              title="閱讀器"
              src={`/screen/bpmfvs/ime/index.html?id=${config.data.id}`}
            ></iframe>
          ) : (
            <div className={`userRead h-100 w-100 ${ config.data.data?.writing }`}>
              {/* <div className="read-bar">
                <div className="read-check form-check form-switch form-switch-md m-0" dir="ltr">
                  <Label className="form-check-label fs-16" htmlFor="writing">橫書</Label>
                  <Input type="checkbox" className="form-check-input" id="writing" onChange={() => writingSwitch()} checked={writingType} />
                  <Label className="form-check-label fs-16" htmlFor="writing">直書</Label>
                </div>
              </div> */}

              <HtmlDisplay isIPad={isIPad} config={config} scale={scale} />
              {/* <div
                className="read-content"
                style={{
                  fontSize: `${isIPad? (config.data.data?.fontSize * scale) : config.data.data?.fontSize}px`,
                  // lineHeight: `${fontSpaceSet? fontSpaceSet : (config.data.data?.writing === "Horizontal"? 1.2 : 2)}`
                  lineHeight: (config.data.data?.writing === "Horizontal"? 1.2 : 2) + Number(config.data.data?.fontSpace) / 10
                }}
              >
                {config.data.data?.html? config.data.data?.html : config.data.data?.content}
              </div> */}
            </div>
          )}

        </div>
        {!username && config.data.selected? (
          <Button 
            className="float-save-btn ml-auto mt-2 continueBtn"
            variant="contained"
            // disabled={inputValue === ""}
            onPointerDown={saveBopomofo}
            data-interaction-target-type={false}
          >
            {!floatBtn? (
              <>
                <div>
                  <img src={bopomofoImg} alt="" />
                </div>
                <span>注音校對</span>
              </>
            ) : (
              <span>儲存</span>
            )}
          </Button>
        ) : null}
      </div>
    </React.Fragment>
  );
};

export default memo(Index);

const HtmlDisplay: React.FC<{ isIPad: boolean, config: any, scale: number }> = ({ isIPad, config, scale }) => {
  // 使用 DOMPurify 清理輸入的 HTML 字符串
  const sanitizedHtml = DOMPurify.sanitize(config.data.data?.html? config.data.data?.html : config.data.data?.content);

  return (
    <div
      className="read-content"
      style={{
        fontSize: `${isIPad? (config.data.data?.fontSize * scale) : config.data.data?.fontSize}px`,
        lineHeight: (config.data.data?.writing === "Horizontal"? 1.2 : 2) + Number(config.data.data?.fontSpace) / 10
      }}
      // 禁用 ESLint 規則 react/no-danger，因為我們確定這裡是安全的
      /* eslint-disable-next-line react/no-danger */
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    >
    </div>
  );
};
